import { type TActiveExperiment, getExperimentListUrl, withQuery } from '@core/api'
import { convertActiveExperiment } from '@core/converters'
import { httpClient } from '@core/http-client'

import { isCrawler } from '../helpers/isCrawler'
import type { TExperimentAssignment, TExperimentSlug } from '../types/experimentTypes'

const FETCH_TIMEOUT_MS = 6000

export const fetchActiveExperiment = async (
    slug: TExperimentSlug,
    member: string,
): Promise<TExperimentAssignment | null> => {
    if (isCrawler(navigator.userAgent)) {
        return null
    }

    const apiActiveExperiments = await httpClient
        .get(withQuery(getExperimentListUrl(), { id: member, slugs: slug }), {
            retry: 0,
            timeout: FETCH_TIMEOUT_MS,
        })
        .json<TActiveExperiment[]>()

    const experiment = apiActiveExperiments
        .map(convertActiveExperiment)
        .find(candidate => candidate.slug === slug)

    return experiment ? { id: Number(experiment.id), variation: experiment.variation } : null
}
